// @generated by TypeGen from LogbookApp/EngineMissingApi.swift - DO NOT EDIT

export interface IEngineHintRequest {
  answer: IEngineHintAnswer;
  engines?: string[];
  since?: IEngineHintSince;
}

export enum IEngineHintAnswer {
  started = "started",
  sailing = "sailing",
}

export enum IEngineHintSince {
  trigger = "trigger",
  now = "now",
}
